export { MedicalConsultationHistory } from './ui';
